/*
  Belvano Konfigurator-Liste (bcl) — Logik für snippets/belvano-config-list.liquid.

  Ersetzt auf der PDP die Ja/Nein-Zubehör-Karten durch eine strukturierte
  Preis-Liste: Bett-Grundzeile + Zubehör-Toggle-Zeilen + Gesamt-Zeile.

  Die Zeilen steuern dieselben versteckten Add-on-Radio-Gruppen der Buy-Box
  fern wie belvano-addons (Checkbox → passendes Radio + change-Event; Preis,
  ATC-Button, Section-Rerender laufen über das Theme-JS).

  Zusätzlich: TOP-PREIS-ENTKOPPLUNG. Der grosse Preis oben soll nur noch den
  Bett-Grundpreis zeigen (gewählte Grösse, ohne Zubehör). Weil Zubehör beim
  Theme aber Varianten-Optionen sind, schreibt das Theme dort den Gesamtpreis
  hinein. Wir überschreiben die Preis-Knoten nach jedem Wechsel wieder auf den
  Basispreis (MutationObserver hält das durch, verhindert das Hochspringen).
*/
if ( typeof customElements.get('belvano-config-list') == 'undefined' ) {

	class BelvanoConfigList extends HTMLElement {

		connectedCallback() {
			if ( document.readyState === 'loading' ) {
				document.addEventListener('DOMContentLoaded', this._setup.bind(this), { once: true });
			} else {
				this._setup();
			}
		}

		_setup() {
			if ( this._bclInit || ! this.isConnected ) return;
			this._bclInit = true;

			this.host = this.closest('product-variants');
			if ( ! this.host ) return;
			try {
				this.variants = JSON.parse(this.querySelector('[data-bcl-variants]').textContent);
			} catch (e) {
				this.variants = [];
			}
			this.cards = [...this.querySelectorAll('[data-bcl-card]')];
			this.baseEl = this.querySelector('[data-bcl-base-price]');
			this.sizeEl = this.querySelector('[data-bcl-size]');
			this.totalEl = this.querySelector('[data-bcl-total]');
			this.heylightEl = this.querySelector('[data-bcl-heylight]');
			this.sizeToggle = this.querySelector('[data-bcl-size-toggle]');
			this.sizePanel = this.querySelector('[data-bcl-size-panel]');
			this.sizeChips = [...this.querySelectorAll('[data-bcl-size-chip]')];
			this.modelsOverlay = this.querySelector('[data-bcl-models]');
			// Mehrere Öffner: Kopfzeile, aktuelles Bett-Thumbnail und „+N".
			// (Einzelne Bett-Thumbnails sind Links → wechseln direkt zum Bett.)
			this.modelsOpeners = [...this.querySelectorAll('[data-bcl-models-open]')];
			this.modelsOpener = this.modelsOpeners[0] || null;

			// Top-Preis-Knoten des Themes (Kompakt-Preis am Titel + erweiterter
			// Preis bei den Kauf-Buttons). Werden auf Basispreis gehalten.
			this._priceNodes = [...document.querySelectorAll(
				'[data-update-block="price-compact-main"], [data-update-block="price-extended-main"]'
			)];

			// Aufklappbare Bett-Zeile: Grössen-Chips steuern die versteckten
			// Grössen-Radios fern (gleiches Muster wie die Zubehör-Zeilen).
			if ( this.sizeToggle ) {
				this.sizeToggle.addEventListener('click', () => this._toggleSizePanel());
			}
			this.sizeChips.forEach(chip => {
				chip.addEventListener('click', () => this._selectSize(chip));
			});

			this.cards.forEach(card => {
				card._steps = this._buildSteps(card);
				card.querySelectorAll('[data-bcl-step]').forEach(btn => {
					btn.addEventListener('click', () => this._stepAddon(card, parseInt(btn.dataset.bclStep, 10)));
				});
				const media = card.querySelector('[data-bcl-zoom]');
				if ( media ) {
					media.addEventListener('click', () => this.openZoom(media));
					media.addEventListener('keydown', e => {
						if ( e.key === 'Enter' || e.key === ' ' ) { e.preventDefault(); this.openZoom(media); }
					});
				}
			});

			// Modell-Popup (Schwester-Betten)
			if ( this.modelsOpeners.length && this.modelsOverlay ) {
				this.modelsOpeners.forEach(op => op.addEventListener('click', () => this.openModels()));
				this.modelsOverlay.querySelectorAll('[data-bcl-models-close]').forEach(el => {
					el.addEventListener('click', () => this.closeModels());
				});
				this.initModelFilters();
			}

			this.host.addEventListener('VARIANT_CHANGE', () => this.sync());

			// Theme ersetzt die Preis-Knoten bei jedem Rerender komplett; ein
			// Observer erzwingt danach sofort wieder den Basispreis (kein Flackern
			// auf den Gesamtpreis). Guard gegen eigene Schreibvorgänge.
			this._observePriceNodes();

			this.sync();
		}

		/* ---- Zubehör-Auswahl fernsteuern (wie belvano-addons) ---- */

		/* Stufen des Steppers: 0 = Ohne, dann (falls Einzel-Variante existiert)
		   1 Stück, dann das Set (data-bcl-pieces Stück). count = Stückzahl. */
		_buildSteps(card) {
			const steps = [{ value: card.dataset.ohne.trim(), pieces: 0 }];
			if ( card.dataset.mitSingle ) {
				steps.push({ value: card.dataset.mitSingle.trim(), pieces: 1 });
			}
			const setPieces = parseInt(card.dataset.bclPieces || '1', 10);
			steps.push({ value: card.dataset.mit.trim(), pieces: setPieces });
			return steps;
		}

		_stepIndex(card, sel) {
			const pos = parseInt(card.dataset.pos, 10);
			const cur = sel[pos];
			const steps = card._steps || this._buildSteps(card);
			let idx = steps.findIndex(s => cur !== null && s.value === String(cur).trim());
			return idx < 0 ? 0 : idx;
		}

		_stepAddon(card, dir) {
			const steps = card._steps || this._buildSteps(card);
			const sel = this.selections();
			let idx = this._stepIndex(card, sel) + dir;
			if ( idx < 0 ) idx = 0;
			if ( idx > steps.length - 1 ) idx = steps.length - 1;
			this._select(card, steps[idx].value);
		}

		_setRadioByGroup(group, value) {
			const radio = [...this.host.querySelectorAll(`input[name="${group}"]`)]
				.find(r => r.value.trim() === value.trim());
			if ( ! radio ) return false;
			if ( ! radio.checked ) {
				radio.checked = true;
				radio.dispatchEvent(new Event('change', { bubbles: true }));
			}
			return true;
		}

		_select(card, value) {
			if ( this._setRadioByGroup(card.dataset.group, value) ) this.sync();
		}

		_toggleSizePanel(force) {
			if ( ! this.sizePanel || ! this.sizeToggle ) return;
			const open = force !== undefined ? force : this.sizePanel.hidden;
			this.sizePanel.hidden = ! open;
			this.sizeToggle.setAttribute('aria-expanded', String(open));
			const row = this.sizeToggle.closest('.bcl-row');
			if ( row ) row.classList.toggle('is-open', open);
		}

		_selectSize(chip) {
			// Panel bleibt offen (Grössen sollen auf einen Blick sichtbar bleiben);
			// nur die Auswahl umsetzen und neu berechnen.
			if ( this._setRadioByGroup(chip.dataset.group, chip.dataset.value) ) this.sync();
		}

		selections() {
			return [...this.host.querySelectorAll('[data-js-product-variant]')].map(group => {
				const checked = group.querySelector('.product-variant__input:checked');
				return checked ? checked.value.trim() : null;
			});
		}

		/* Günstigste Variante mit options[pos] == value und übrigen Optionen wie
		   gewählt; null, wenn die Kombination nicht existiert. pos = -1 → nur die
		   übrigen Auswahlen berücksichtigen (für Basis/Gesamt). */
		matchFor(pos, value, sel) {
			let best = null;
			this.variants.forEach(v => {
				for ( let k = 0; k < v.options.length; k++ ) {
					const opt = String(v.options[k]).trim();
					if ( k === pos ) {
						if ( opt !== value ) return;
					} else if ( sel[k] !== null && opt !== sel[k] ) {
						return;
					}
				}
				if ( best === null || v.price < best.price ) best = v;
			});
			return best;
		}

		/* Bett-Grundpreis = günstigste Variante mit der gewählten Grösse und
		   allen Zubehör-Optionen auf ihrem "Ohne"-Wert. */
		baseVariant(sel) {
			const size = sel[0];
			let best = null;
			this.variants.forEach(v => {
				if ( size !== null && String(v.options[0]).trim() !== size ) return;
				let allOhne = true;
				this.cards.forEach(card => {
					const pos = parseInt(card.dataset.pos, 10);
					if ( String(v.options[pos]).trim() !== card.dataset.ohne.trim() ) allOhne = false;
				});
				if ( ! allOhne ) return;
				if ( best === null || v.price < best.price ) best = v;
			});
			// Fallback: günstigste Variante der Grösse
			if ( ! best ) best = this.matchFor(0, size, [size]);
			return best;
		}

		/* Aktuell gewählte Vollvariante (inkl. Zubehör) = echter Gesamtpreis. */
		currentVariant(sel) {
			let best = null;
			this.variants.forEach(v => {
				for ( let k = 0; k < v.options.length; k++ ) {
					if ( sel[k] !== null && String(v.options[k]).trim() !== sel[k] ) return;
				}
				if ( best === null || v.price < best.price ) best = v;
			});
			return best;
		}

		fmt(rappen) {
			const chf = rappen / 100;
			const txt = chf.toLocaleString('de-CH', {
				minimumFractionDigits: Number.isInteger(chf) ? 0 : 2,
				maximumFractionDigits: 2
			}).replace(/['’\s]/g, "'");
			return 'CHF ' + txt;
		}

		/* HeyLight BNPL 0% — kurze Zeile „oder N × CHF" (Rappen) + ⓘ, das das
		   HeyLight-Popup öffnet (belvano-heylight-info.js, delegierter Klick).
		   Abstand per &nbsp; abgesichert (kein Flex-Whitespace-Kollaps). Leerer
		   String = keine Zeile (Betrag ausserhalb CHF 600–20'000). */
		_heylightHtml(total) {
			const MIN_INSTAL = 20000, MIN = 60000, MAX = 2000000;
			const terms = [3, 4, 6, 10, 12];
			if ( ! total || total < MIN || total > MAX ) return '';
			const ceiling = total / MIN_INSTAL;
			const acc = terms.filter(t => t <= ceiling);
			if ( ! acc.length ) return '';
			const term = acc[acc.length - 1];
			const monthly = Math.round(total / term);
			return 'oder ' + term + '&nbsp;&times;&nbsp;<strong>' + this.fmt(monthly) + '</strong>'
				+ ' <button type="button" class="blv-hl-i" data-heylight-info data-hl-amount="' + total + '" aria-label="Ratenzahlung mit HeyLight — Infos">'
				+ '<svg class="bv-stroke-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.4"/><path d="M10 9v4.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><circle cx="10" cy="6.4" r="1" fill="currentColor"/></svg>'
				+ '</button>';
		}

		_deltaText(mit, ohne) {
			if ( ! mit || ! ohne ) return null;
			const delta = mit.price - ohne.price;
			if ( delta === 0 ) return 'inklusive';
			return (delta > 0 ? '+ ' : '− ') + this.fmt(Math.abs(delta));
		}

		/* Aufpreis schlicht: 2er-Sets zeigen den Einzel-/Stückpreis (Set-Preis /
		   Stück), Einzelstücke ihren Preis — jeweils OHNE «+»/«N ×»-Präfix. */
		_deltaTextPieces(mit, ohne, pieces) {
			if ( ! mit || ! ohne ) return null;
			const delta = mit.price - ohne.price;
			if ( delta === 0 ) return 'inklusive';
			if ( delta > 0 && pieces > 1 ) {
				return this.fmt(Math.round(delta / pieces));
			}
			return (delta > 0 ? '' : '− ') + this.fmt(Math.abs(delta));
		}

		/* ---- Live-Aktualisierung ---- */

		sync() {
			const sel = this.selections();
			const base = this.baseVariant(sel);

			this.cards.forEach(card => {
				const pos = parseInt(card.dataset.pos, 10);
				const steps = card._steps || this._buildSteps(card);
				const idx = this._stepIndex(card, sel);
				const step = steps[idx];
				const added = idx > 0;

				card.classList.toggle('is-added', added);

				// Stückzahl im Stepper
				const countEl = card.querySelector('[data-bcl-count]');
				if ( countEl ) countEl.textContent = step.pieces;

				// Zählabhängiger Name: «1 Nachttisch» vs «2 Nachttische». Der
				// Basis-Titel (singular) bleibt bei 0 stehen. Nur Karten mit
				// hinterlegten Nomen-Formen (aktuell Nachttisch) werden dynamisch.
				const nameEl = card.querySelector('.bcl-row__name');
				if ( nameEl ) {
					if ( card._baseName === undefined ) card._baseName = nameEl.textContent;
					const nOne = card.dataset.bclNounOne;
					const nMany = card.dataset.bclNounMany;
					if ( nOne && added ) {
						nameEl.textContent = step.pieces + ' ' + ( step.pieces === 1 ? nOne : nMany );
					} else {
						nameEl.textContent = card._baseName;
					}
				}

				// Preis: bei Auswahl der Gesamtpreis der aktuellen Menge; bei 0 der
				// Preis von EINEM (Einzel-Schritt bevorzugt, sonst Set ÷ Stück).
				let previewStep = steps[steps.length - 1];
				for ( const s of steps ) { if ( s.pieces === 1 ) { previewStep = s; break; } }
				const offerStep = added ? step : previewStep;
				const ohne = this.matchFor(pos, card.dataset.ohne, sel);
				const mit = this.matchFor(pos, offerStep.value, sel);
				const deltaEl = card.querySelector('[data-bcl-delta]');
				// added → Gesamtpreis der Menge (kein Pro-Stück); 0 → Pro-Stück-Vorschau
				const dispPieces = added ? 1 : offerStep.pieces;
				const text = this._deltaTextPieces(mit, ohne, dispPieces);
				if ( deltaEl ) deltaEl.textContent = text === null ? '—' : text;
				card.classList.toggle('bcl-row--soldout', !! mit && ! mit.available);

				// Stepper-Buttons sperren an den Rändern / bei nicht existierender Kombi
				const minusBtn = card.querySelector('[data-bcl-step="-1"]');
				const plusBtn = card.querySelector('[data-bcl-step="1"]');
				if ( minusBtn ) minusBtn.disabled = idx === 0;
				if ( plusBtn ) {
					let plusOff = idx >= steps.length - 1;
					if ( ! plusOff ) plusOff = this.matchFor(pos, steps[idx + 1].value, sel) === null;
					plusBtn.disabled = plusOff;
				}
			});

			// Bett-Grundzeile + aktive Grössen-Chip-Markierung
			if ( this.sizeEl && sel[0] ) this.sizeEl.textContent = sel[0].replace(/\s*cm$/i, '');
			if ( this.baseEl && base ) this.baseEl.textContent = this.fmt(base.price);
			this.sizeChips.forEach(chip => {
				const on = sel[0] !== null && chip.dataset.value.trim() === sel[0].trim();
				chip.classList.toggle('is-on', on);
				chip.setAttribute('aria-pressed', String(on));
			});

			// Gesamt-Zeile (echter Endpreis)
			const total = this.currentVariant(sel) || base;
			if ( this.totalEl && total ) this.totalEl.textContent = this.fmt(total.price);

			// HeyLight BNPL 0% live am Gesamtpreis (kurze Zeile + ⓘ-Popup)
			if ( this.heylightEl ) this.heylightEl.innerHTML = total ? this._heylightHtml(total.price) : '';

			// Top-Preis oben auf Bett-Grundpreis halten
			this._base = base;
			this._applyBasePrice();
		}

		/* ---- Top-Preis-Entkopplung ---- */

		_observePriceNodes() {
			if ( ! this._priceNodes.length || typeof MutationObserver === 'undefined' ) return;
			this._observer = new MutationObserver(() => {
				if ( this._writing ) return;
				this._applyBasePrice();
			});
			this._priceNodes.forEach(node => {
				this._observer.observe(node, { childList: true, subtree: true, characterData: true });
			});
		}

		_applyBasePrice() {
			if ( ! this._base || ! this._priceNodes.length ) return;
			const price = this._base.price;
			const compare = this._base.compare || 0;
			this._writing = true;
			this._priceNodes.forEach(node => {
				node.querySelectorAll('.product-price--original').forEach(el => {
					// nur den Geldbetrag ersetzen, Screenreader-Label bewahren
					const hidden = el.querySelector('.visually-hidden');
					el.textContent = '';
					if ( hidden ) el.appendChild(hidden);
					el.appendChild(document.createTextNode(this.fmt(price)));
				});
				// Sichtbarer Streichpreis-Betrag = zweiter span; der erste ist das
				// visually-hidden „Regulär:"-Label. NICHT `span` allgemein greifen,
				// sonst landet der Basispreis im unsichtbaren Label und der vom Theme
				// gerenderte Varianten-Compare bleibt sichtbar stehen.
				const del = node.querySelector('.product-price--compare');
				if ( del ) {
					let amt = del.querySelector('span:not(.visually-hidden)');
					if ( compare > price ) {
						if ( ! amt ) { amt = document.createElement('span'); del.appendChild(amt); }
						amt.textContent = this.fmt(compare);
					} else if ( amt ) {
						amt.textContent = '';
					}
				}
				const saleRow = node.querySelector('.belvano-price-sale-row');
				if ( saleRow ) saleRow.style.display = compare > price ? '' : 'none';
				const saving = node.querySelector('.product-price--saving');
				if ( saving ) {
					saving.style.display = compare > price ? '' : 'none';
					const sv = saving.querySelector('span');
					if ( sv && compare > price ) sv.textContent = 'Sie sparen ' + this.fmt(compare - price);
				}
			});
			// Guard erst im nächsten Frame lösen, damit unsere eigenen Mutationen
			// den Observer nicht erneut auslösen.
			requestAnimationFrame(() => { this._writing = false; });
		}

		/* ---- Modell-Popup (Schwester-Betten) ---- */

		openModels() {
			if ( ! this.modelsOverlay ) return;
			// Overlay ans <body> hängen, damit es keinen Stacking-Context der
			// Section/Buy-Box erbt und garantiert über dem Header liegt.
			if ( this.modelsOverlay.parentNode !== document.body ) {
				document.body.appendChild(this.modelsOverlay);
			}
			this.modelsOverlay.hidden = false;
			document.body.style.overflow = 'hidden';
			this._modelsKey = e => { if ( e.key === 'Escape' ) this.closeModels(); };
			document.addEventListener('keydown', this._modelsKey);
			const focusTarget = this.modelsOverlay.querySelector('.is-current, .bcl-model-card, .bcl-models__close');
			if ( focusTarget ) focusTarget.focus();
		}

		closeModels() {
			if ( ! this.modelsOverlay ) return;
			this.modelsOverlay.hidden = true;
			document.body.style.overflow = '';
			if ( this._modelsKey ) document.removeEventListener('keydown', this._modelsKey);
			if ( this.modelsOpener ) this.modelsOpener.focus();
		}

		/* ---- Modell-Filter (gleiche Achsen wie die Collection-Filter) ---- */

		initModelFilters() {
			const mf = this.modelsOverlay.querySelector('[data-bcl-mf]');
			if ( ! mf ) return;
			this.mfRoot = mf;
			this.mfCards = Array.from(this.modelsOverlay.querySelectorAll('.bcl-model-card'));
			this.mfShown = mf.querySelector('[data-bcl-mf-shown]');
			this.mfEmpty = this.modelsOverlay.querySelector('[data-bcl-mf-empty]');

			// Karten-Preisregel bei Grössen-Filter (wie auf der Collection-Seite):
			// Default-Preis + -Link je Karte merken, Grössen-Preisdaten (gv) parsen.
			this.mfCards.forEach(card => {
				const pe = card.querySelector('[data-bcl-card-price]');
				card._priceEl = pe;
				card._defaultPrice = pe ? pe.innerHTML : '';
				card._defaultHref = card.getAttribute('href') || '';
				try { card._gv = JSON.parse(card.dataset.gv || '{}'); } catch (e) { card._gv = {}; }
			});
			this.mfAllCount = mf.querySelector('[data-bcl-mf-allcount]');
			this.mfApply = mf.querySelector('.bcl-mf-sheet__apply');

			const chips = mf.querySelector('.bcl-mf__chips');
			const sheet = mf.querySelector('[data-bcl-mf-sheet]');
			const sheetBody = mf.querySelector('[data-bcl-mf-sheet-body]');
			const groups = Array.from(mf.querySelectorAll('.bcl-mf__chip'));
			this.mfBarReset = chips ? chips.querySelector('[data-bcl-mf-reset]') : null;

			// Filter-Modal: Gruppen beim Öffnen ins Modal schieben, beim Schliessen zurück
			// (exakt wie die Collection-Bar). In der Leiste öffnen die Chips direkt das Modal.
			const openSheet = focus => {
				groups.forEach(g => { g.open = false; sheetBody.appendChild(g); });
				if ( focus ) focus.open = true;
				sheet.hidden = false;
			};
			const closeSheet = () => {
				groups.forEach(g => {
					g.open = false;
					if ( this.mfBarReset ) chips.insertBefore(g, this.mfBarReset);
					else chips.appendChild(g);
				});
				sheet.hidden = true;
			};

			const allBtn = mf.querySelector('[data-bcl-mf-all]');
			if ( allBtn ) allBtn.addEventListener('click', () => openSheet(null));

			groups.forEach(g => {
				const sum = g.querySelector('summary');
				if ( ! sum ) return;
				sum.addEventListener('click', e => {
					if ( g.parentElement === sheetBody ) return; // im Modal normal auf/zu
					e.preventDefault();
					openSheet(g);
				});
			});

			if ( sheet ) {
				sheet.querySelectorAll('[data-bcl-mf-sheet-close]').forEach(el => {
					el.addEventListener('click', () => closeSheet());
				});
			}

			mf.addEventListener('change', () => this.applyModelFilters());
			mf.querySelectorAll('[data-bcl-mf-reset]').forEach(r => {
				r.addEventListener('click', () => {
					mf.querySelectorAll('input[type="checkbox"]').forEach(c => { c.checked = false; });
					this.applyModelFilters();
				});
			});

			this.applyModelFilters();
		}

		applyModelFilters() {
			if ( ! this.mfRoot ) return;
			const groups = {};
			this.mfRoot.querySelectorAll('[data-mf]').forEach(det => {
				const key = det.getAttribute('data-mf');
				const sel = [];
				det.querySelectorAll('input:checked').forEach(inp => {
					if ( key === 'price' ) {
						sel.push({
							min: parseInt(inp.dataset.min, 10) || 0,
							max: inp.dataset.max ? parseInt(inp.dataset.max, 10) : Infinity,
						});
					} else {
						sel.push(inp.dataset.mfVal);
					}
				});
				groups[key] = sel;
				const badge = det.querySelector('[data-mf-badge]');
				if ( badge ) badge.textContent = sel.length ? sel.length : '';
				det.classList.toggle('is-active', sel.length > 0);
			});

			let shown = 0, anyActive = false;
			this.mfCards.forEach(card => {
				let ok = true;
				for ( const key in groups ) {
					const sel = groups[key];
					if ( ! sel.length ) continue;
					anyActive = true;
					if ( key === 'price' ) {
						const p = parseInt(card.dataset.price, 10) || 0;
						if ( ! sel.some(r => p >= r.min && p < r.max) ) { ok = false; break; }
					} else if ( key === 'g' ) {
						const sizes = card.dataset.sizes || '';
						if ( ! sel.some(v => sizes.indexOf('|' + v + '|') !== -1) ) { ok = false; break; }
					} else {
						const attr = key === 'f' ? card.dataset.farbe
							: key === 'h' ? card.dataset.hell
							: card.dataset.stoff;
						if ( sel.indexOf(attr || '') === -1 ) { ok = false; break; }
					}
				}
				card.hidden = ! ok;
				if ( ok ) shown++;
			});

			// Karten-Preisregel: gewählte Grösse(n) → deren Preis + Varianten-Link
			this.updateModelCardPrices(groups.g || []);

			if ( this.mfShown ) this.mfShown.textContent = shown;
			if ( this.mfBarReset ) this.mfBarReset.hidden = ! anyActive;
			if ( this.mfEmpty ) this.mfEmpty.hidden = shown > 0;

			const totalChecked = this.mfRoot.querySelectorAll('input:checked').length;
			if ( this.mfAllCount ) this.mfAllCount.textContent = totalChecked ? '(' + totalChecked + ')' : '';
			if ( this.mfApply ) this.mfApply.textContent = shown + (shown === 1 ? ' Ergebnis anzeigen' : ' Ergebnisse anzeigen');
		}

		// Wie belvano-filter-bar-js: genau eine gefilterte Grösse am Modell →
		// exakter Preis dieser Grösse + Deeplink auf die Variante; mehrere →
		// «Ab» + günstigste; keine Grösse gewählt → Standard («ab …», Produkt-URL).
		updateModelCardPrices(sizes) {
			this.mfCards.forEach(card => {
				if ( ! card._priceEl ) return;
				const gv = card._gv || {};
				const hits = [];
				sizes.forEach(s => { if ( gv[s] ) hits.push(gv[s]); });

				if ( ! hits.length ) {
					card._priceEl.innerHTML = card._defaultPrice;
					card.setAttribute('href', card._defaultHref);
					return;
				}
				hits.sort((a, b) => a[1] - b[1]);
				const v = hits[0];
				const from = hits.length > 1;
				let html = (from ? 'Ab ' : '') + v[2];
				if ( v[3] ) html += ' <del class="bcl-model-card__compare">' + v[3] + '</del>';
				card._priceEl.innerHTML = html;
				const base = (card._defaultHref || card.getAttribute('href') || '').split('?')[0];
				card.setAttribute('href', base + '?variant=' + v[0]);
			});
		}

		/* ---- Bild-Overlay (wie belvano-addons) ---- */

		openZoom(media) {
			const existing = document.querySelector('.bcl-zoom');
			if ( existing ) existing.remove();
			const label = media.getAttribute('aria-label') || '';
			const wrap = document.createElement('div');
			wrap.className = 'bcl-zoom';
			wrap.innerHTML = `
				<div class="bcl-zoom__backdrop"></div>
				<div class="bcl-zoom__panel" role="dialog" aria-label="${label}">
					<button type="button" class="bcl-zoom__close" aria-label="Schliessen">&times;</button>
					<img src="${media.dataset.bclZoom}" alt="${label}">
				</div>`;
			document.body.appendChild(wrap);
			const close = () => { wrap.remove(); document.removeEventListener('keydown', onKey); };
			const onKey = e => { if ( e.key === 'Escape' ) close(); };
			wrap.querySelector('.bcl-zoom__backdrop').addEventListener('click', close);
			wrap.querySelector('.bcl-zoom__close').addEventListener('click', close);
			document.addEventListener('keydown', onKey);
		}

	}

	customElements.define('belvano-config-list', BelvanoConfigList);

}
